<template>
  <div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management ref="baseListManagementRef" :configData.sync="configData" />
  </div>
</template>

<script>
import { configDataFn } from '../config/list'

export default {
  name: 'CouponActivityList',
  data() {
    const initialFormData = {}
    if (this.$route.query.activityId !== undefined && this.$route.query.activityId !== null) {
      initialFormData.id = String(this.$route.query.activityId)
    }
    return {
      configData: configDataFn({
        goDataDetail: this.goDataDetail,
        judgePermission: (permission) => this.judgePermission(permission),
        initialFormData,
      }),
    }
  },
  methods: {
    goDataDetail(row) {
      this.$router.push({
        path: '/activity/coupon/grantRecord',
        query: {
          activityId: row.activityId,
          couponName: row.couponName,
        },
      })
    },
  },
}
</script>
